import React from "react";
import "./styles.scss";
import { GreenTick } from "../../assets/svgs";
import { getBankLogos } from "../../utils/svgUtils";

const SelectedBankBadge = ({
  connectedBank,
  alt = "Bank",
  selected = true,
}) => {
  const bankLogo = getBankLogos(connectedBank);
  return (
    <div className="selected-bank-badge">
      <div className="bank-logo-wrapper">
        {bankLogo && <img src={bankLogo} alt={alt} className="bank-logo" />}
        {selected && (
          <div className="check-badge">
            <img src={GreenTick} alt="tick" />
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectedBankBadge;
